import { Dispatch } from '@reduxjs/toolkit'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'

import { marketingSlice } from './marketing.slice'

export const fetchLuckyDrawActivityTypesAction = (
  tradingAccountsApiClient: TradingAccountsApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await tradingAccountsApiClient.getLuckyDrawActivityTypes()
      dispatch(marketingSlice.actions.setLuckyDrawActivityTypesAction(response))
    } catch (e) {
      console.error('Error during get lucky draw activity types', e)
    }
  }
}

export const fetchLuckyDrawRewardTypesAction = (
  tradingAccountsApiClient: TradingAccountsApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await tradingAccountsApiClient.getLuckyDrawRewardTypes()
      dispatch(marketingSlice.actions.setLuckyDrawRewardTypesAction(response))
    } catch (e) {
      console.error('Error during get lucky draw reward types', e)
    }
  }
}

export const fetchMarginBonusWithdrawRulesAction = (
  tradingAccountsApiClient: TradingAccountsApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await tradingAccountsApiClient.getMarginBonusOptionsWithdrawRules()
      dispatch(marketingSlice.actions.setMarginBonusWithdrawRulesAction(response))
    } catch (e) {
      console.error('Error during get margin bonus withdraw rules', e)
    }
  }
}

export const fetchMarginBonusLabelsAction = (
  tradingAccountsApiClient: TradingAccountsApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await tradingAccountsApiClient.getMarginBonusLabels()
      dispatch(marketingSlice.actions.setMarginBonusLabelsAction(response))
    } catch (e) {
      console.error('Error during get margin bonus labels', e)
    }
  }
}

export const fetchMarginBonusAvailabilityPeriodsAction = (
  tradingAccountsApiClient: TradingAccountsApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await tradingAccountsApiClient.getMarginBonusAvailabilityPeriods()
      dispatch(marketingSlice.actions.setMarginBonusAvailabilityPeriodsAction(response))
    } catch (e) {
      console.error('Error during get margin bonus availability periods', e)
    }
  }
}

export const fetchMarginBonusCountdownTriggersAction = (
  tradingAccountsApiClient: TradingAccountsApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await tradingAccountsApiClient.getMarginBonusCountdownTriggers()
      dispatch(marketingSlice.actions.setMarginBonusCountdownTriggersAction(response))
    } catch (e) {
      console.error('Error during get margin bonus countdown triggers', e)
    }
  }
}

export const fetchMarginBonusExcludeTypesAction = (
  tradingAccountsApiClient: TradingAccountsApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await tradingAccountsApiClient.getMarginBonusExcludeTypes()
      dispatch(marketingSlice.actions.setMarginBonusExcludeTypesAction(response))
    } catch (e) {
      console.error('Error during get margin bonus exclude types', e)
    }
  }
}
